import { render, staticRenderFns } from "./Diag.vue?vue&type=template&id=27bbfbce&scoped=true&"
import script from "./Diag.vue?vue&type=script&lang=js&"
export * from "./Diag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bbfbce",
  null
  
)

component.options.__file = "Diag.vue"
export default component.exports